export interface SideMenuState {
  readonly persistent: boolean;
  readonly collapsed: boolean;
  readonly sideMenuKey: number;
}

export const INITIAL_SIDE_MENU_STATE: SideMenuState = {
  persistent: true,
  collapsed: true,
  sideMenuKey: 0,
};
